import initMemberBookingsNavToggle from '../src/js/member-bookings-nav';

document.addEventListener('DOMContentLoaded', () => {
  initMemberBookingsNavToggle();
});
